import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { closeModal } from '../actions/ui';
import { updateTask, deleteTask } from '../actions/task';
import useForm from '../hooks/useForm';
import ModalWrapper from './ModalWrapper';

const TaskEditModal = ({
  modal,
  updateTask,
  deleteTask,
  closeModal,
  history,
}) => {
  const { values, handleInputChange } = useForm({
    name: modal.task.name,
  });

  // const onSuccess = () => {
  //   console.log('success');
  //   closeModal();
  // };

  const handleSubmit = () => {
    if (!values.name || !modal.task._id) return;

    updateTask(modal.task._id, values, closeModal);
  };

  const handleDelete = () => {
    if (!modal.task._id) return;

    if (window.confirm('Are you sure you want to delete this task?'))
      deleteTask(modal.task._id, () => {
        closeModal();
        history.push(`/project/${modal.task.projects[0]._id}`);
      });
  };

  return (
    <TaskEditModalComponent
      values={values}
      inputChangeHandler={handleInputChange}
      submitHandler={handleSubmit}
      deleteHandler={handleDelete}
      closeModalHandler={closeModal}
    />
  );
};

const TaskEditModalComponent = ({
  values,
  inputChangeHandler,
  submitHandler,
  deleteHandler,
  closeModalHandler,
}) => (
  <ModalWrapper title="Edit task">
    <section className="modal-card-body">
      <div className="field">
        <div>
          <label
            className="is-block is-size-7 is-uppercase has-text-weight-bold mb-1"
            htmlFor="name"
          >
            Task name
          </label>
        </div>

        <div className="field-body">
          <div className="field">
            <p className="control">
              <input
                className="input"
                id="name"
                name="name"
                type="text"
                value={values.name}
                onChange={inputChangeHandler}
              />
            </p>
          </div>
        </div>
      </div>
    </section>

    <footer className="modal-card-foot">
      <button
        type="button"
        className="button is-success"
        onClick={submitHandler}
      >
        Save changes
      </button>

      <button type="button" className="button" onClick={closeModalHandler}>
        Cancel
      </button>

      <button
        type="button"
        className="button has-margin-left-auto is-danger"
        onClick={deleteHandler}
      >
        Delete task
      </button>
    </footer>
  </ModalWrapper>
);

const mapActionToProps = {
  updateTask,
  deleteTask,
  closeModal,
};

export default connect(null, mapActionToProps)(withRouter(TaskEditModal));
